<script>
import { mapGetters } from 'vuex'
export default {
    name: 'BannerLanding',
    components: {},
    data() {
        return {
            loaded: false,
            banner: null,
        }
    },
    computed: {
        ...mapGetters({
            model: 'banners/model',
        }),
        bannerId() {
            return this.$route.query.bannerId
        },
    },
    watch: {
        $route() {
            this.load()
        },
    },
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            this.banner = null
            if (!this.bannerId) {
                return false
            }

            await this.$store.dispatch('banners/fetch', this.bannerId)
            this.banner = this.model
        },
    },
}
</script>

<template lang="pug">
.banner-landing(v-if="banner")
    h1 {{  banner.landingPage.title }}
    p {{  banner.landingPage.description }}    
</template>
